<template>
  <div id="app">
    
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  // name: 'App',
  // components: {
  // }
}
</script>
<style src="../public/css/common.css"></style>
<style>
@import './assets/css/fonts.css';
html {
  /* font-size: 37.5px; 假设设计稿宽度为750px */
}



</style>
